var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnslLink',{attrs:{"href":_vm.href,"name":_vm.name,"params":_vm.params,"variant":_vm.variant}},[_c('TcButton',[_vm._v(" "+_vm._s(_vm.buttonText)+" "),_c('img',{attrs:{"src":require("@/assets/external_link.svg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }